import React, { useRef, useState, useEffect } from "react";
import "./background.css";

import happyImg from "./happy.png";
import sadImg from "./sad.png";
import calmImg from "./calm.avif";
import excitedImg from "./excited.jpg";
import angryImg from "./angry.jpg";
import surprisedImg from "./surprise.webp";
import sleepyImg from "./sleepy.webp";
import loveImg from "./love.jpg";

function Background() {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [captured, setCaptured] = useState(false);
  const [selectedMood, setSelectedMood] = useState("");
  const [showMoodSelector, setShowMoodSelector] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);

  const moodBackgrounds = {
    Happy: happyImg,
    Sad: sadImg,
    Calm: calmImg,
    Excited: excitedImg,
    Angry: angryImg,
    Surprised: surprisedImg,
    Sleepy: sleepyImg,
    Love: loveImg,
  };

  useEffect(() => {
    const getVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Error accessing webcam: ", err);
      }
    };
    getVideo();

    return () => {
      if (videoRef.current?.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (!canvas || !video) return;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageSrc = canvas.toDataURL("image/jpeg");
    setCapturedImage(imageSrc);
    setCaptured(true);
    setShowMoodSelector(true);
  };

  const applyMoodBackground = (mood) => {
    if (!capturedImage) return;
    setSelectedMood(mood);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      ctx.font = "64px serif";
      ctx.textAlign = "center";

      const emojis = {
        Happy: ["😀", "🎉", "🎉"],
        Sad: ["😢", "💧", "💧"],
        Calm: ["🧘", "☁️", "☁️"],
        Excited: ["🥳", "🎊", "🎊"],
        Angry: ["😡", "💢", "💢"],
        Surprised: ["😮", "❗", "❗"],
        Sleepy: ["😴", "💤", "💤"],
        Love: ["❤️", "😍", "😍"],
      };

      const moodEmojis = emojis[mood] || [];
      ctx.fillText(moodEmojis[0], 200, 150);
      ctx.fillText(moodEmojis[1], 150, 250);
      ctx.fillText(moodEmojis[2], 250, 250);

      setShowMoodSelector(false);
    };
    img.src = capturedImage;
  };

  return (
    <>
      <div className="scanner-background" />

      <div className="studio-container">
        <h1 className="studio-title">🎨 Mood-Based Virtual Studio</h1>

        <div className="studio-content">
          <div>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              width="400"
              height="300"
              className="webcam-box"
            />

            <canvas
              ref={canvasRef}
              width="400"
              height="300"
              className="webcam-box"
              style={{ display: captured ? "block" : "none" }}
            />

            {!captured && !showMoodSelector && (
              <button onClick={capturePhoto} className="capture-btn">
                Capture Photo 📸
              </button>
            )}

            {captured && (
              <button
                onClick={() => {
                  setCaptured(false);
                  setSelectedMood("");
                  setShowMoodSelector(false);
                  setCapturedImage(null);
                }}
                className="retake-btn"
              >
                Retake Photo 🔄
              </button>
            )}
          </div>

          {showMoodSelector && (
            <div className="mood-options-vertical">
              {Object.keys(moodBackgrounds).map((mood, index) => (
                <div
                  key={index}
                  onClick={() => applyMoodBackground(mood)}
                  className="mood-card"
                >
                  <img src={moodBackgrounds[mood]} alt={mood} />
                  <p className="mood-name">{mood}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Background;